import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  HomeLogo,
  ServicesLogo,
  SolutionLogo,
  CaseStudyLogo,
  TechnologyLogo,
  InsideLogo,
  ContactLogo,
  LocationLogo,
  langIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

function MobileHeader({ lang }) {
  const [isActive, setIsActive] = useState(false);
  const [isLocActive, setLocActive] = useState(false);
  const [isInsActive, setInsActive] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(!scrolled);
      }
    };
    document.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [scrolled]);

  const handleClick = (event) => {
    event.currentTarget.classList.toggle("active");
    setIsActive((current) => !current);
    setLocActive(false);
    setInsActive(false);
    document.body.classList.toggle("active");
  };
  const backClick = (event) => {
    setIsActive(true);
    setLocActive(false);
    setInsActive(false);
  };
  const subLocationMenu = (event) => {
    event.currentTarget.classList.toggle("active");
    setLocActive((current) => !current);
  };
  const subInsightsMenu = (event) => {
    event.currentTarget.classList.toggle("active");
    setInsActive((current) => !current);
  };
  return (
    <nav className="tekrevol_menu mobile_view active">
      <ul>
        <li>
          <Link to="/" className="nav_link" onClick={handleClick}>
            {HomeLogo} Home
          </Link>
        </li>
        <li>
          <Link to="/services" className="nav_link" onClick={handleClick}>
            {ServicesLogo} services
          </Link>
        </li>
        <li>
          <Link to="/solution" className="nav_link" onClick={handleClick}>
            {SolutionLogo} Solution
          </Link>
        </li>
        <li>
          <Link to="/technologies" className="nav_link" onClick={handleClick}>
            {TechnologyLogo} Technologies
          </Link>
        </li>
        {/* <li className="mega">
          <Link to="/location" className="nav_link" onClick={handleClick}>
            {LocationLogo} Location
          </Link>
        </li> */}
        <li>
          <Link to="/projects" className="nav_link" onClick={handleClick}>
            {CaseStudyLogo} Portfolio
          </Link>
        </li>
        <li className="mega">
          <Link to="#" className="nav_link" onClick={subInsightsMenu}>
            {InsideLogo}Insights
          </Link>
          <div className={!isInsActive ? "mega_menu" : "mega_menu active"}>
            <Container>
              <Row className="lightbg_menu">
                <span onClick={backClick}> Back </span>
                <h4>Insights</h4>
                <Col xs={12} md={9} lg={9} xl={9} xxl={9}>
                  <div className="cateorgy_namee">
                    <div className="menu_items">
                      <li>
                        <Link to="/about" onClick={handleClick}>
                          About TekRevol
                        </Link>
                      </li>
                      <li>
                        <Link to="/life-at-tekrevol" onClick={handleClick}>
                          Life at Tekrevol
                        </Link>
                      </li>
                      <li>
                        <a href="https://www.tekrevol.com/blogs/" onClick={handleClick}>
                          Blogs
                        </a>
                      </li>
                      <li>
                        <Link to="/press-release" onClick={handleClick}>
                          Press
                        </Link>
                      </li>

                      <li>
                        <Link to="/podcast" onClick={handleClick}>
                          Podcast
                        </Link>
                      </li>
                      <li>
                        <Link to="/events" onClick={handleClick}>
                          Events
                        </Link>
                      </li>
                      <li>
                        {/* <Link to="/referral-program" onClick={handleClick}>
                          Referral Program
                        </Link> */}
                        <a href="https://www.tekrevol.com/blogs/partnership-program/" onClick={handleClick}>
                          Referral Program
                        </a>
                      </li>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </li>

        {lang === "arbic_dubai" ? (
          <li onClick={handleClick}>
            <Link
              to="/mobile-app-development-company-dubai"
              className="nav_link"
            >
              {langIcon}EN
            </Link>
          </li>
        ) : lang === "eng_dubai" ? (
          <li onClick={handleClick}>
            <Link
              to="/ar/mobile-app-development-company-dubai"
              className="nav_link"
            >
              {langIcon}عربي
            </Link>
          </li>
        ) : lang === "arbic_saudi" ? (
          <li onClick={handleClick}>
            <Link
              to="/sa/mobile-apps-development-in-saudi-arabia"
              className="nav_link"
            >
              {langIcon} EN
            </Link>
          </li>
        ) : lang === "eng_saudi" ? (
          <li onClick={handleClick}>
            <Link
              to="/sa/تصميم-تطبيقات-الجوال-في-السعودية"
              className="nav_link"
            >
              {langIcon} عربي
            </Link>
          </li>
        ) : (
          ""
        )}

        <li>
          <Link to="/contact" className="btn_primary" onClick={handleClick}>
            {ContactLogo} Get A Quote
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default MobileHeader;
